module.exports = __webpack_public_path__ + "6890ddcca99a5494c412bbd062e27b1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gorgutz-panel-1080.jpg
// module id = 372
// module chunks = 0